export default defineAppConfig({});

export const uninteractiveButtonClasses =
  "focus:outline-none focus-visible:outline-0 disabled:cursor-default disabled:opacity-75 flex-shrink-0";

export const wideModalClasses =
  "sm:max-w-lg md:max-w-2xl lg:max-w-4xl xl:max-w-5xl";
